import { Broker } from "@amzn/amazonmq-opsconsole-client"
import React, { memo } from "react";
import { getRabbitMetricAgentMetrics } from "./metrics/rabbitMetricAgentMetrics";
import CloudWatchDashboard from "./CloudWatchDashboard";

type Props = {
    broker: Broker
}

const RabbitMetricAgentTab : React.FC<Props> = ({broker}) => {
    let widgets = getRabbitMetricAgentMetrics(broker);

    return (
        <div>
            <CloudWatchDashboard
                broker={broker}
                layoutType='automatic'
                widgetsPerRow={2}
                serviceAccountId={broker.summary.serviceAccountId}
                widgets={widgets}
            />
        </div>
    )
}

export default memo(RabbitMetricAgentTab);

